module.exports = __webpack_public_path__ + "icons.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/json-tree-viewer/libs/jsonTree/icons.svg
// module id = 2223
// module chunks = 67